import type React from 'react'
import type { IconProps } from './types'

const ChevLeftIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M14.58 20L16 18.58L9.42 12L16 5.42L14.58 4L6.58 12L14.58 20Z' />
	</svg>
)

export default ChevLeftIcon
